import { render } from "./bigmap.vue?vue&type=template&id=3bcff9e8&scoped=true"
import script from "./bigmap.vue?vue&type=script&lang=js"
export * from "./bigmap.vue?vue&type=script&lang=js"

import "./bigmap.vue?vue&type=style&index=0&id=3bcff9e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcff9e8"]])

export default __exports__